const stateColors = {
  draft: "gray",
  cancelled: "rose",
  quotation: "amber",
  processing: "indigo",
  transferred: "sky",
  done: "lime",
};

function layout() {
  let ctxView = {
    model: "product.product",
    tags: {
      state: stateColors,
    },
    // images: {
    //   type: "image",
    //   // Component: ModalSIngleProduct,
    //   visible: () => true,
    //   readOnly: false,
    //   style: null,
    // },

    form_action: ["edit"],
    table_action: [],
    activeSearch: true,
    domain: [],
    fields: {
      name: {
        type: "char",
        readOnly: false,
      },
      quantity: {
        type: "integer",
        editable: true,
      },
      size: {
        type: "selection",
        editable: true,
      },
    },
    form: [],
    list: [{ name: "name" }, { name: "size" }, { name: "quantity" }],
  };

  return ctxView;
}

export { layout };
